"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.EMeetingUserAction = void 0;
var EMeetingUserAction;
(function (EMeetingUserAction) {
  /** Могу открыть конференцию */
  EMeetingUserAction["open"] = "open";
  /** Могу открыть конференцию прямо сейчас */
  EMeetingUserAction["autoOpen"] = "autoOpen";
  /** Могу изменить общие сведения */
  EMeetingUserAction["edit"] = "edit";
  /** Могу продлить митинг */
  EMeetingUserAction["extend"] = "extend";
  /** Могу стартовать конференцию */
  EMeetingUserAction["start"] = "start";
  /** Могу закончить конференцию */
  EMeetingUserAction["finish"] = "finish";
  /** Могу пригласить участников */
  EMeetingUserAction["invite"] = "invite";
  /** могу отозвать приглашение */
  EMeetingUserAction["withdrawInvitation"] = "withdrawInvitation";
  /** Могу принять приглашение */
  EMeetingUserAction["acceptInvitation"] = "acceptInvitation";
  /** Могу отклонить приглашение */
  EMeetingUserAction["declineInvitation"] = "declineInvitation";
  /** Могу принять приглашение с оплатой */
  EMeetingUserAction["paidAcceptInvitation"] = "paidAcceptInvitation";
  /** Могу присоединиться (по ссылке) */
  EMeetingUserAction["join"] = "join";
  /** Могу присоединиться (по ссылке) с оплатой */
  EMeetingUserAction["paidJoin"] = "paidJoin";
  /** Смогу присоединиться (по ссылке) после авторизации */
  EMeetingUserAction["authJoin"] = "authJoin";
  /** Смогу присоединиться (по ссылке) с оплатой после авторизации */
  EMeetingUserAction["authPaidJoin"] = "authPaidJoin";
  /** Могу предложить перенести время */
  EMeetingUserAction["reschedule"] = "reschedule";
  /** Могу принять предложение на перенос времени */
  EMeetingUserAction["acceptReschedule"] = "acceptReschedule";
  /** Могу отказаться от предложения на перенос времени */
  EMeetingUserAction["rejectReschedule"] = "rejectReschedule";
  /** Могу отменить предложение на перенос времени */
  EMeetingUserAction["withdrawReschedule"] = "withdrawReschedule";
  /** Могу отменить */
  EMeetingUserAction["cancel"] = "cancel";
  /** Могу отменить со штрафом */
  EMeetingUserAction["cancelWithPenalty"] = "cancelWithPenalty";
  /** Могу покинуть митинг (=выйти из участиников) */
  EMeetingUserAction["leave"] = "leave";
  /** Могу покинуть митинг (=выйти из участиников) со штрафом */
  EMeetingUserAction["leaveWithPenalty"] = "leaveWithPenalty";
  /**
   * @deprecated
   */
  EMeetingUserAction["withdrawCancel"] = "withdrawCancel";
  /**
   * @deprecated
   */
  EMeetingUserAction["interactWithMeeting"] = "interactWithMeeting";
  /**
   * @deprecated
   */
  EMeetingUserAction["interactWithMeetingInvite"] = "interactWithMeetingInvite";
  /** Могу оценить */
  EMeetingUserAction["review"] = "review";
})(EMeetingUserAction = exports.EMeetingUserAction || (exports.EMeetingUserAction = {}));
